<template>
  <div>
    <div class="download_header">
      <div class="links">
        <button
          v-on:click="onClickDownload()"
          class="link"
          :disabled="enableDisable"
          style="background-color: var(--primary-color-background)"
        >
          <QSpinner size="sm" color="grey-7" v-if="loadingDownload" style="margin-left: -3px; margin-top: -3px" />
          <i class="uiw-font-download" style="color: var(--primary-color); margin-left: -10px" v-else />
          <!-- <img src="/assets/icons/download.svg" v-else /> -->
        </button>
        <button
          v-on:click="
            show = !show;
            sendButtonTxt = 'Send';
          "
          class="link"
          :disabled="enableDisable"
          style="background-color: var(--primary-color-background)"
        >
          <i class="uiw-font-email" style="color: var(--primary-color); margin-left: -5px" />
          <!-- <img src="/assets/icons/email.svg" /> -->
        </button>
      </div>
      <div class="text">{{ text }}</div>
    </div>
    <div class="download_email" v-if="show">
      <QForm @submit.prevent="onSubmitNext">
        <div class="row">
          <div class="col-8">
            <QInput
              ref="field"
              outlined
              v-model="email"
              placeholder="email"
              :rules="getRules()"
              type="email"
              v-on:blur="onBlur()"
              lazy-rules
            />
          </div>
          <div class="col-4">
            <QBtn outline color="primary" class="full-width" type="submit" no-caps :loading="loadingSendEmail" :disable="enableDisable">
              {{ sendButtonTxt }}</QBtn
            >
          </div>
        </div>
      </QForm>
    </div>
  </div>
</template>

<script>
/**
 * This component represents common UI for displaying the status in the progress list
 */
import { QBtn, QInput, QForm, QSpinner } from 'quasar';
export default {
  name: 'DocumentDownload',
  components: { QInput, QBtn, QForm, QSpinner },
  props: {
    text: String,
    wetSignatureObjName: String,
    enableDisable: Boolean,
    loadingDownloadProp: Boolean,
    loadingSendEmailProp: Boolean
  },
  watch: {
    loadingDownloadProp: function (newValue) {
      this.loadingDownload = newValue;
    },
    loadingSendEmailProp: function (newValue) {
      this.loadingSendEmail = newValue;
    }
  },
  data: function () {
    return {
      sendButtonTxt: 'Send',
      loadingDownload: false,
      loadingSendEmail: false,
      show: false,
      email: ''
    };
  },
  methods: {
    onClickDownload: function () {
      setTimeout(() => {
        this.$emit('onClickDownload', this.wetSignatureObjName);
      });
    },
    onSubmitNext: function () {
      setTimeout(() => {
        this.$emit('onClickSendEmail', this.wetSignatureObjName, this.email);
        this.sendButtonTxt = 'Sent';
      });
    },
    onBlur: function () {
      this.validate = true;
      this.$refs.field.validate();
    },
    getRules: function () {
      const rules = [];
      rules.push((val) => {
        if (!val || val == '') {
          return 'Field is required';
        }
        return true;
      });
      rules.push((val) => {
        if (this.validate && !this.validateEmail(val)) {
          return 'Field needs to be an email address';
        }
        return true;
      });
      return rules;
    },
    validateEmail: function (email) {
      const re =
        /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/;
      return re.test(String(email).toLowerCase());
    }
  }
};
</script>

<style lang="sass" scoped>
.download_header
  border: 1px solid #EEEEEE;
  border-radius: 1px;
  padding: 10px 15px;
  margin-bottom: 10px;
.download_email
  margin-bottom: 30px;
.col-4
  padding-left: 10px;
/deep/ .q-field__control
  height: 41px;
  min-height: 41px;
.links
  float: right;
.text
  padding: 10px 0;
.link
  padding: 9px;
  width: 36px;
  height: 36px;
  border-radius: 6px;
  border: none;
  outline: none;
  background: #F1F7FB;
  display: inline-block;
  vertical-align: middle;
  text-align: center;
  margin-left: 5px;
  margin-top: 3px;
  cursor: pointer;
</style>
